import * as styles from "./FormInputFieldWrapper.css";
import { ComponentPropsWithoutRef, ComponentPropsWithRef } from "react";
import DrawnCircle from "~/assets/svgs/DrawnCircle";
import { Check, X } from "@untitled-ui/icons-react";
import { fluid } from "~/styles/functions";
import { WrapperDrawnBorder } from "../wrappers/WrapperDrawnBorder";
import clsx from "clsx";

type FormInputFieldWrapperProps = {
  selected?: boolean;
  theme?: "primary" | "positive" | "negative";
} & ComponentPropsWithoutRef<"div">;

export const FormInputFieldWrapper = ({
  children,
  selected = false,
  theme = "primary",
  ...props
}: FormInputFieldWrapperProps) => {
  return (
    <div
      className={clsx(props.className, styles.theme({ theme: theme }))}
      {...props}
    >
      <div className={styles.card}>
        <WrapperDrawnBorder style={{ width: "100%" }}>
          {children}
        </WrapperDrawnBorder>
        <div className={styles.radioButtonWrapper}>
        <div className={styles.radioButton}>
          <DrawnCircle className={styles.circle({ selected: selected })} />
          <div className={styles.icons({ selected: selected })}>
            <div className={styles.icon}>
              {theme == "negative" ? (
                <X width={fluid("12.5px")} height={fluid("12.5px")} />
              ) : (
                <Check width={fluid("12.5px")} height={fluid("12.5px")} />
              )}
            </div>
            <div className={styles.icon}>
              {theme == "negative" ? (
                <X width={fluid("12.5px")} height={fluid("12.5px")} />
              ) : (
                <Check width={fluid("12.5px")} height={fluid("12.5px")} />
              )}
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};
